"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = resolveFunctionOrReturnValue;

function resolveFunctionOrReturnValue(fnOrValue) {
  return typeof fnOrValue === 'function' ? fnOrValue() : fnOrValue;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9yZXNvbHZlRnVuY3Rpb25PclJldHVyblZhbHVlLmpzIl0sIm5hbWVzIjpbInJlc29sdmVGdW5jdGlvbk9yUmV0dXJuVmFsdWUiLCJmbk9yVmFsdWUiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBZSxTQUFTQSw0QkFBVCxDQUFzQ0MsU0FBdEMsRUFBaUQ7QUFDOUQsU0FBTyxPQUFPQSxTQUFQLEtBQXFCLFVBQXJCLEdBQWtDQSxTQUFTLEVBQTNDLEdBQWdEQSxTQUF2RDtBQUNEIiwic291cmNlUm9vdCI6ImRpcmVjdGxpbmVzcGVlY2g6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gcmVzb2x2ZUZ1bmN0aW9uT3JSZXR1cm5WYWx1ZShmbk9yVmFsdWUpIHtcbiAgcmV0dXJuIHR5cGVvZiBmbk9yVmFsdWUgPT09ICdmdW5jdGlvbicgPyBmbk9yVmFsdWUoKSA6IGZuT3JWYWx1ZTtcbn1cbiJdfQ==